var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Field } from 'react-final-form';
import FFFieldListnerWrapper from '../inputs/FFFieldListnerWrapper';
import Radio from '../inputs/Radio';
var FFRadio = function (_a) {
    var fieldProps = _a.fieldProps, componentProps = _a.componentProps, onFieldBlur = _a.onFieldBlur, onFieldChange = _a.onFieldChange, onFieldFoucus = _a.onFieldFoucus;
    return (React.createElement(FFFieldListnerWrapper, { name: fieldProps.name, onFieldBlur: onFieldBlur, onFieldChange: onFieldChange, onFieldFoucus: onFieldFoucus },
        React.createElement(Field, __assign({}, fieldProps, { render: function (_a) {
                var _b, _c;
                var _d = _a.input, type = _d.type, restInput = __rest(_d, ["type"]), meta = _a.meta;
                return (React.createElement(Radio, __assign({}, restInput, { error: (_b = Boolean(meta.touched && meta.error)) !== null && _b !== void 0 ? _b : componentProps === null || componentProps === void 0 ? void 0 : componentProps.error, helperText: (_c = (meta.touched ? meta.error : undefined)) !== null && _c !== void 0 ? _c : componentProps === null || componentProps === void 0 ? void 0 : componentProps.helperText }, componentProps, { onChange: function (event, value) {
                        var _a;
                        restInput.onChange(value);
                        if (event) {
                            (_a = componentProps === null || componentProps === void 0 ? void 0 : componentProps.onChange) === null || _a === void 0 ? void 0 : _a.call(componentProps, event, value);
                        }
                    } })));
            } }))));
};
export default FFRadio;
//# sourceMappingURL=FFRadio.js.map